import { StatisticalAnalysisGeneralStatisticsDossierBaseRequest, StatisticalAnalysisGeneralStatisticsDossierGroupRequest } from '@/modules/statistical-analysis-module/services/general-statistics-dossier/general-statistics-dossier.dto'
import { generalStatisticsDossierService } from '@/modules/statistical-analysis-module/services/general-statistics-dossier/general-statistics-dossier.service'
import { Nullable } from '@/shared/types/app.types'
import { StatisticalAnalysisViewDetailChartData, StatisticalAnalysisViewDetailChartFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart/statistical-analysis-view-detail-chart.model'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisCaseTypes } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalAnalysisGeneralDossierExternalInfo } from '@/modules/statistical-analysis-module/views/general-statistics-dossier/general-statistics-dossier.model'
import { Options } from 'highcharts'
import i18n from '@/lang/i18n'

export class StatisticalAnalysisHandlerChartGeneralDossier {
    protected statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailChartFilters>
    constructor(statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailChartFilters>) {
        this.statisticalAnalysisFilters = statisticalAnalysisFilters
    }

    public async getChart(): Promise<Options> {
        const sidebarFilter = this.statisticalAnalysisFilters?.externalFiltering.sidebarFilters as StatisticalAnalysisGeneralDossierExternalInfo
        const baseRequest: StatisticalAnalysisGeneralStatisticsDossierBaseRequest = generalStatisticsDossierService.getBaseRequest(sidebarFilter)
        const groupRequest: StatisticalAnalysisGeneralStatisticsDossierGroupRequest = {
            groupBy1: this.statisticalAnalysisFilters?.xAxis.groupBy1 as string,
            groupBy2: this.statisticalAnalysisFilters?.xAxis.groupBy2 as string
        }
        const typeCase = sidebarFilter?.typeSearch?.id as StatiscalAnalysisTypeCases
        const state = sidebarFilter.trackingGeneralSelected?.key as StatisticalAnalysisCaseTypes
        const subState = sidebarFilter.trackingDetailSelected?.key as StatisticalAnalysisCaseTypes
        const response: StatisticalAnalysisViewDetailChartData = await generalStatisticsDossierService.getDetailViewChart(typeCase, state, subState, baseRequest, groupRequest)

        return {
            xAxis: {
                categories: response.categories
            },
            yAxis: {
                title: {
                    text: `${i18n.tc('statisticalAnalysis.charts.totalOf')} ${i18n.tc(sidebarFilter?.typeSearch?.text as string, 2).toLocaleLowerCase()}`
                }
            },
            series: response.series
        }
    }
}
